// extracted by mini-css-extract-plugin
export default {"block":"GrayCardBlueIcon_block__1mjf2","text-container":"GrayCardBlueIcon_text-container__6c1C4"};